import { svg } from "uhtml";
import { locales } from "../../models/locales.js";

export function closeIcon(locale) {
  return svg`
		<svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" role="img" class="svgIcon use">
      <defs>
        <symbol id="close-icon" viewBox="0 0 19 19">
          <title>${locales.closeIcon[locale]}</title>
          <path d="M9.5.96C4.736.96.86 4.836.86 9.6s3.876 8.64 8.64 8.64c4.764 0 8.641-3.877 8.641-8.64 0-4.764-3.877-8.64-8.641-8.64zm0 16.669c-4.427 0-8.029-3.602-8.029-8.029S5.073 1.571 9.5 1.571s8.029 3.602 8.029 8.029-3.602 8.029-8.029 8.029z"></path><path d="M12.494 6.606a.304.304 0 0 0-.432 0L9.5 9.168 6.938 6.606a.306.306 0 0 0-.432.432L9.068 9.6l-2.562 2.562a.304.304 0 0 0 0 .432c.06.062.138.09.216.09a.296.296 0 0 0 .216-.09L9.5 10.032l2.562 2.562c.059.062.138.09.215.09a.306.306 0 0 0 .217-.522L9.932 9.6l2.562-2.562a.306.306 0 0 0 0-.432z"></path>
        </symbol>
      </defs>
    </svg>`;
}
